import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Profile } from '@/types/profile'

export function getProfile(customConfig = {}): Promise<AxiosResponse<Profile>> {
  return instance.get(`/iam/testUserPermissions`, { ...customConfig })
}
